module.exports = __webpack_public_path__ + "img/bullseye.127c5d53.svg";